import anime from "animejs";
import barba from "@barba/core";
import ImagesLoaded from "@utils/imagesloaded";

import { $ } from "@utils/dom";

import { EMITTER } from "@core/barba.webpack-chunks";

const SELECTOR = "[data-site-transition]";
const WAITING_CLASSNAME = "--js-waiting";

class SiteTransition {
  constructor() {
    this.el = $(SELECTOR);
    this.backdrop = $(".site-transition__invertedBackdrop", this.el);
    this.circleShape = $(".site-transition__circleShape", this.el);
    this.logo = $('.site-transition__logo', this.el);
    this.name = "transition";
    this.emitter = EMITTER;

    this._imagesLoaded = false;
    this._imgLoader = null;
    this._timeoutID = null;

    this._onImagesLoaded = this._onImagesLoaded.bind(this);
    this._onWaitForTransition = this._onWaitForTransition.bind(this);
  }

  beforeLeave({ next }) {
    this._imagesLoaded = false;
    this._timeoutID = setTimeout(this._onWaitForTransition, 2500);

    // if next.container is not loaded, try again during `beforeEnter` hook.
    if (!next.container) return;

    // preload images from next container during leave transition
    // do not wait to images preloading to finish to start leave transition
    this._imgLoader = new ImagesLoaded(next.container, this._onImagesLoaded);
  }

  beforeEnter({ next }) {
    // if images are loaded, skip here
    if (this._imagesLoaded === true) return;

    return new Promise((resolve) => {
      // if imagesLoaded has not been initialized, because next.container was null in `beforeLeave` hook.
      if (!this._imgLoader) this._imgLoader = new ImagesLoaded(next.container, this._onImagesLoaded);

      // wait until images are loaded
      this._imgLoader.once("always", resolve);
    });
  }

  leave(data) {
    return new Promise((resolve) => {
      anime.timeline({
        easing: 'easeInOutSine',
        duration: 450,
        complete: () => {
          barba.transitions.remove(data);
          resolve()
        },
      })
      .add({
        targets: this.circleShape,
        scaleY: [0, 1]
      })
      .add({
        targets: this.el,
        translateY: [`100%`, `0%`],
      }, '-=300')
      .add({
        targets: this.backdrop,
        opacity: [0, 1],
      }, '+=300')

      this.el.classList.remove("visibility-hidden");
    });
  }

  enter() {
    if( this._timeoutID ) {
      clearTimeout(this._timeoutID);
      this._timeoutID = null;
    }

    return new Promise((resolve) => {
      anime({
        targets: this.el,
        opacity: [1, 0],
        duration: 250,
        easing: "linear",
        complete: () => {
          // reset
          this.el.classList.add("visibility-hidden");
          this.el.classList.remove(WAITING_CLASSNAME);
          this.el.removeAttribute('style');

          // emit to other modules that site-transition is ready
          this.emitter.emit('SiteTransition.ready');
          resolve();
        }
      });
    });
  }

  _onImagesLoaded() {
    this._imagesLoaded = true;

    this._imgLoader.destroy();
    this._imgLoader = null;
  }
  _onWaitForTransition() {
    this.el.classList.add(WAITING_CLASSNAME);
    this._timeoutID = null;
  }
}

export default SiteTransition;
